import { createBrowserViewSettingsRepository } from '@emfit/shared-store';

/** View settings for every configurable view */
export const ViewSettingsRepository = createBrowserViewSettingsRepository('care');
